/** Message's capsule label (components.md 3): "Message Ana" only where the name is not already on the line. */
export function messageLabel(name: string, withName: boolean): string {
  return withName && name ? `Message ${name}` : 'Message';
}
